import { IconButton, Tooltip } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import React from 'react';
import { CSVLink } from "react-csv";
import theme from '../../../styles/theme';

const ExportCsvButton = ({
    headCells = {},
    data = []
}) => {
    const [headers, setHeaders] = React.useState([])

    const handleUpdateHeaders = () => {
        let updatedHeaders = []
        Object.values(headCells).map(eachValue => {
            if (!eachValue.hideInCsvExport) {
                updatedHeaders.push({ label: eachValue.label, key: eachValue.id })
            }
        })
        setHeaders(updatedHeaders)
    }

    React.useEffect(() => {
        handleUpdateHeaders()
    }, [headCells])

    return (
        <CSVLink data={data} headers={headers} filename={"download.csv"}>
            <Tooltip title={"Export to CSV"} style={{ color: theme.palette.primary.main }}>
                <IconButton aria-label="Export to CSV">
                    <GetApp />
                </IconButton>
            </Tooltip>
        </CSVLink>
    )
}

export default ExportCsvButton
